export var AISessionState = /*#__PURE__*/function (AISessionState) {
  AISessionState["unset"] = "[AIInteraction]:UNSET";
  AISessionState["initiated"] = "[AIInteraction]:INITIATED";
  AISessionState["viewed"] = "[AIInteraction]:VIEWED";
  AISessionState["error"] = "[AIInteraction]:ERROR";
  AISessionState["dismissed"] = "[AIInteraction]:DISMISSED";
  AISessionState["actioned"] = "[AIInteraction]:ACTIONED";
  AISessionState["discarded"] = "[AIInteraction]:DISCARDED";
  AISessionState["submitted"] = "[AIInteraction]:SUBMITTED";
  return AISessionState;
}({});
export var EventDispatcherSources = /*#__PURE__*/function (EventDispatcherSources) {
  EventDispatcherSources["JSLib"] = "name:@atlassian/ai-analytics|language:javascript";
  return EventDispatcherSources;
}({});